<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :expand-on-hover="expandOnHover"
    :src="barImage"
    mobile-break-point="960"
    app
    mini-variant-width="80"
    width="260"
    v-bind="$attrs"
  >
    <template v-slot:img="props">
      <v-img :gradient="`to bottom, ${barColor}`" v-bind="props" />
    </template>

<!--    <v-list-item two-line>-->
<!--      <v-list-item-content>-->
<!--        <v-list-item-title class="text-uppercase font-weight-regular display-2">-->
<!--          <span class="logo-mini">VH</span>-->
<!--          <span class="logo-normal">CRM</span>-->
<!--        </v-list-item-title>-->
<!--      </v-list-item-content>-->
<!--    </v-list-item>-->

    <div style="padding-top: 12px; text-align: right;">
      <template v-if="projectType === 'INTERNATIONAL'">
      <img
          :width="isHover ? 80 : 95"
          :height="isHover ? 35 : 30"
          class="mr-2"
          src="../../assets/logo-rino.png"/>
      </template>
      <template v-else>
        <img
            :width="isHover ? 65 : 95"
            :height="isHover ? 15 : 22"
            class="mr-2"
            src="../../assets/logo.png"/>
      </template>
    </div>

    <v-divider class="mb-1"/>

    <v-list dense nav style="position: relative">
      <base-item class="item-sidebar" :item="profile" />
      <div v-if="profile.isCTV" class="text-center title-module-sale no-manager">
        <span>Đối tác - Tất cả </span>
      </div>
      <div v-else-if="profile.isMarketing" class="text-center title-module-sale no-manager">
        <span>Marketing - Tất cả </span>
      </div>
      <v-row v-else
             style="height: 50px;"
             class="title-module-sale pr-4 wrapper-is-manager">
        <v-col cols="12" md="6" class="pr-0">
          <v-autocomplete
              v-model="filterForm.typeId"
              :items="listType"
              item-text="name"
              item-value="id"
              label=""
              @change="changeDrawer()"
              placeholder="Loại hình"
              hide-details
          />
        </v-col>

        <v-col cols="12" md="6" class="pr-0">
          <v-autocomplete
              v-model="filterForm.schoolLevelId"
              :items="typeSchoolLevels"
              item-text="name"
              item-value="id"
              label=""
              @change="changeDrawer()"
              :readonly="!filterForm.typeId || filterForm.typeId == 'partner'"
              placeholder="Nhóm ngành"
              hide-details
          />
        </v-col>
      </v-row>
    </v-list>

    <v-divider class="mb-2" />

    <v-list expand nav>
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />

      <template v-for="(item, i) in computedItems">
        <!-- -->
        <template v-if="showInSidebar(item.roles, item.title)">
          <base-item-group class="item-sidebar" v-if="item.children" :key="`group-${i}`"  :item="item">
            <!--  -->
          </base-item-group>

          <base-item v-else :key="`item-${i}`" :item="item" :class="item.to==''? 'classActive':''"/>
        </template>
      </template>

      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />
    </v-list>
  </v-navigation-drawer>
</template>

<script>
const roleUsers = [
  'kpi_read',
  'kpi_create',
  'kpi_update',
  'kpi_delete',
  'schedule_read',
  'schedule_create',
  'schedule_update',
  'schedule_delete',
  'schedule_view_all',
  'appointment_read',
  'appointment_create',
  'appointment_update',
  'appointment_delete',
  'appointment_view_all',
];
const roleCallCenter = [
  'call_center_read',
  'call_center_delete',
  'call_center_view_all',
  'general-call-center-report_read',
  'employee-call-center-report_read'
];

const roleReport = [
  'result-report_read',
  'employee-report_read',
  'status-report_read',
  'contact-source-report_read',
  'best-employee_read',
  'sale-leader_read',
  'product-group-revenue-report_read',
  'customer-revenue-report_read',
  'personal-report_read',
  'contact-register_read',
  'employee-report-a-department_read',
];
const roleDataSetting = [
  'contact-setting_read',
  'contact-setting_create',
  'contact-setting_update',
  'contact-setting_delete',
  'contact-source_read',
  'contact-source_create',
  'contact-source_update',
  'contact-source_delete',
  'contact-status_read',
  'contact-status_create',
  'contact-status_update',
  'contact-status_delete',
  'announcement_read',
  'announcement_create',
  'announcement_update',
  'announcement_delete',
  'priority-setting_read',
  'keep-contact-setting_read'
];

const roleMktSms = [
    'mkt-sms-message_read',
    'mkt-sms-customer_read',
    'mkt-sms-message-history_read'
];

const roleSettingOrganization = [
  'setting-organization_read',
  'setting-organization_create',
  'setting-organization_update',
  'setting-organization_delete',
  'setting-role_read',
  'setting-role_create',
  'setting-role_update',
  'setting-role_delete',
  'user_read',
  'user_create',
  'user_update',
  'user_delete',
  'user_view_all',
  'setting-kpi_read',
  'setting-kpi_create',
  'setting-kpi_update',
  'setting-kpi_delete'
]

const roleMkt = [
  'marketer-report_read',
  'marketer-report_view_all',
  'marketing-report-by-content_read',
  'marketing-report-by-content_view_all',
  'contact-register_read',
]

export const PARTNER = 'partner'
// Utilities
import { mapState } from 'vuex';
import TokenService from '../../helpers/token';
import { checkMobile } from '../../helpers/utils';
import RepositoryFactory from '../../repositories/RepositoryFactory';
const SchoolLevelRepository = RepositoryFactory.get('school_level')
const TypeRepository = RepositoryFactory.get('type')
const UserRepository = RepositoryFactory.get('user')
export default {
  name: 'DashboardCoreDrawer',
  data: () => ({
    itemsManager: [
      {
        to: '',
        title: 'QUẢN TRỊ TƯ VẤN',
        roles: ['contact_read'],
      },
       {
        icon: 'mdi-view-dashboard',
        title: 'Dashboard tổng',
        to: '/contact/contact-list',
        roles: ['contact_read', 'contact_view_all', 'search_all_read']
      },
      {
        group: '',
        icon: 'mdi-account',
        title: 'Dữ liệu tổng',
        roles: roleUsers,
        children: [
          {
            title: 'Người dùng',
            to: 'users/user-list',
            roles: ['user_read', 'user_create', 'user_update', 'user_delete', 'user_view_all']
          },
          // {
          //   title: 'Phòng ban',
          //   to: 'users/department-list',
          //   roles: [
          //     'department_read',
          //     'department_create',
          //     'department_update',
          //     'department_delete'
          //   ]
          // },
          {
            title: 'KPI',
            to: 'users/kpi',
            roles: ['kpi_read', 'kpi_create', 'kpi_update', 'kpi_delete']
          },
          {
            title: 'Lịch làm việc',
            to: 'users/schedule-list',
            roles: [
              'schedule_read',
              'schedule_create',
              'schedule_update',
              'schedule_delete',
              'schedule_view_all'
            ]
          },
          {
            title: 'Lịch hẹn',
            to: 'users/appointment',
            roles: [
              'appointment_read',
              'appointment_create',
              'appointment_update',
              'appointment_delete',
              'appointment_view_all'
            ]
          }
        ]
      },
      {
        group: '/call-center',
        icon: 'mdi-file-document',
        title: 'Lịch sử cuộc gọi',
        roles: roleCallCenter,
        children: [
          {
            title: 'Danh sách cuộc gọi',
            to: 'list',
            roles: [
              'call_center_read',
              'call_center_delete',
              'call_center_view_all'
            ]
          },
          {
            title: 'Báo cáo call center',
            to: 'general-report',
            roles: ['general-call-center-report_read']
          },
          {
            title: 'Báo cáo cuộc gọi nhân viên',
            to: 'employee-report',
            roles: ['employee-call-center-report_read']
          }
        ]
      },
      {
        to: '/orders/order-list',
        icon: 'mdi-cash-multiple',
        title: 'Danh sách đơn hàng',
        roles: ['order_read', 'order_create', 'order_update', 'order_delete', 'order_view_all'],
      },
      {
        to: '/orders/receipt-list',
        icon: 'mdi-cash-multiple',
        title: 'Danh sách phiếu thu',
        roles: ['order_read', 'order_create', 'order_update', 'order_delete', 'order_view_all'],
      },
      {
        group: '/allotment',
        icon: 'mdi-brightness-7',
        title: 'Phân bổ contact',
        roles: ['setting-contact_read', 'setting-contact_update'],
        children: [
          {
            title: 'Lộ trình phân bổ',
            to: 'list',
            roles: ['setting-contact_read', 'setting-contact_update']
          },
          {
            icon: 'mdi-folder-account',
            title: 'Cơ cấu phân bổ',
            to: 'struct',
            roles: ['contact_read']
          }
        ]
      },
      {
        group: '/products',
        icon: 'mdi-clipboard-outline',
        title: 'Quản lý sản phẩm',
        roles: [
          'product_read',
          'product_create',
          'product_update',
          'product_delete'
        ],
        children: [
          {
            title: 'Sản phẩm',
            to: 'product-list',
            roles: [
              'product_read',
              'product_create',
              'product_update',
              'product_delete'
            ]
          },
          {
            title: 'Nhóm sản phẩm',
            to: 'product-group-list',
            roles: [
              'product_read',
              'product_create',
              'product_update',
              'product_delete'
            ]
          },
          {
            title: 'Combo sản phẩm',
            to: 'combo-list',
            roles: [
              'product_read',
              'product_create',
              'product_update',
              'product_delete'
            ]
          }
        ]
      },
      {
        to: '',
        title: 'MARKETING',
        roles: [ ...roleMkt, ...roleMktSms ],
      },
      {
        group: '/report',
        icon: 'mdi-chart-bar',
        title: 'Marketing zone',
        roles: [ ...roleMkt, ...roleMktSms ],
        children: [
          {
            title: 'Báo cáo marketer',
            to: 'marketing-report-by-marketer',
            roles: ['marketer-report_read']
          },
          {
            title: 'Báo cáo content',
            to: 'marketing-report-by-content',
            roles: ['marketing-report-by-content_read']
          },
          {
            title: 'Báo cáo đăng ký theo ngày',
            to: 'contact-register',
            roles: ['contact-register_read']
          },
          {
            group: '/sms',
            // icon: 'mdi-message-settings',
            title: 'Marketing SMS',
            roles: roleMktSms,
            children: [
              {
                title: 'Danh sách',
                to: 'sms-list?tab=1',
                roles: ['mkt-sms-customer_read']
              },
              {
                title: 'Lịch sử gửi tin',
                to: 'sms-history',
                roles: ['mkt-sms-message-history_read']
              },
            ]
          },
        ]
      },
      {
        title: 'Báo cáo messenger',
        to: '/report/performance-mkt',
        icon: 'mdi-chart-tree',
        roles: ['performance-mkt_read']
      },
      {
        title: 'Khai báo mã content',
        to: '/report/define-facebook-page-responsible',
        icon: 'mdi-chart-bar',
        roles: ['define-master-content_read']
      },
      {
        icon: 'mdi-face-agent',
        title: 'Data BC messenger',
        to: '/bitu-chat',
        roles: ['performancep-mkt-detail_read']
      },
      {
        title: 'Short Link',
        to: '/report/short-link',
        icon: 'mdi-link-variant',
        roles: ['short-link_read']
      },
      {
        to: '',
        title: 'BÁO CÁO',
        roles: ['module-report_read', 'account-report_read', 'general-report_read'],
      },
      {
        group: '/report',
        icon: 'mdi-account',
        title: 'Báo cáo quản trị',
        roles: ['module-report_read', 'account-report_read', 'general-report_read'],
        children: [
          {
            title: 'Báo cáo module',
            icon: 'mdi-chart-bar',
            to: 'module-report',
            roles: ['module-report_read']
          },
          {
            title: 'Báo cáo module V2',
            icon: 'mdi-chart-bar',
            to: 'module-report-v2',
            roles: ['module-report_read']
          },
          {
            title: 'Báo cáo module chung',
            icon: 'mdi-chart-bar',
            to: 'general-module-report',
            roles: ['module-report_read']
          },
          {
            title: 'Báo cáo tài khoản',
            icon: 'mdi-chart-bar',
            to: 'account-report',
            roles: ['account-report_read']
          },
          {
            title: 'Báo cáo chung',
            icon: 'mdi-chart-bar',
            to: 'general',
            roles: ['general-report_read']
          }
        ]
      },
      {
        to: '',
        title: 'CÀI ĐẶT',
        roles: [ ...roleDataSetting, ...roleSettingOrganization ],
      },
      {
        group: '/data-setting',
        icon: 'mdi-server',
        title: 'Cài đặt hệ thống',
        roles: roleDataSetting,
        children: [
          {
            title: 'Cài đặt khách hàng',
            to: 'contact-setting',
            roles: [
              'contact-setting_read',
              'contact-setting_create',
              'contact-setting_update',
              'contact-setting_delete'
            ]
          },
          {
            title: 'Nguồn khách hàng',
            to: 'contact-source-list',
            roles: [
              'contact-source_read',
              'contact-source_create',
              'contact-source_update',
              'contact-source_delete'
            ]
          },
          {
            title: 'Mối quan hệ',
            to: 'contact-status',
            roles: [
              'contact-status_read',
              'contact-status_create',
              'contact-status_update',
              'contact-status_delete'
            ]
          },
          {
            title: 'Thông báo',
            to: 'announcement',
            roles: ['announcement_read', 'announcement_create', 'announcement_update', 'announcement_delete']
          },
          {
            title: 'Nhóm ngành',
            to: 'school-level',
            roles: ['school-level_read', 'school-level_create', 'school-level_update', 'school-level_delete']
          },
          {
            title: 'Quản lý kho',
            to: 'store',
            roles: ['admin-search_read']
          },
          {
            title: 'Cấu hình độ ưu tiên',
            icon: 'mdi-chart-bar',
            to: 'priority',
            roles: ['priority-setting_read']
          },
          {
            title: 'Cấu hình ngày giữ contact',
            icon: 'mdi-chart-bar',
            to: 'hold-contact',
            roles: ['keep-contact-setting_read']
          }
        ]
      },
      {
        group: '/setting',
        icon: 'mdi-server',
        title: 'Cài đặt tổ chức',
        roles: roleSettingOrganization,
        children: [
          {
            title: 'Tổ chức bộ máy',
            to: 'org-machine/struct',
            roles: ['setting-organization_read', 'setting-organization_create', 'setting-organization_update', 'setting-organization_delete']
          },
          {
            title: 'Nhóm quyền',
            to: 'role',
            roles: ['setting-role_read','setting-role_create','setting-role_update','setting-role_delete']
          },
          {
            title: 'Quản lý nhân sự',
            to: 'org-machine/employee-manager',
            roles: ['user_read', 'user_create', 'user_update', 'user_delete', 'user_view_all']
          },
          {
            title: 'Quản lý bộ chỉ số KPI',
            to: 'org-machine/kpi-manager',
            roles: ['setting-kpi_read', 'setting-kpi_create', 'setting-kpi_update', 'setting-kpi_delete']
          }
        ]
      },
      {
        to: '',
        title: 'HỖ TRỢ',
        roles: ['contact_read', 'dashboard_read'],
      },
      // {
      //   icon: 'mdi-face-agent',
      //   title: 'Hỗ trợ CSKH',
      //   to: '/customer-support',
      //   roles: ['contact_read', 'dashboard_read']
      // },
      // {
      //   icon: 'mdi-face-agent',
      //   title: 'Hỗ trợ CSKH',
      //   to: '/customer-support-new',
      //   roles: ['contact_read', 'dashboard_read']
      // },
      {
          icon: 'mdi-face-agent',
          title: 'Hỗ trợ CSKH',
          to: '/customer-support-v2',
          roles: 'all'
      },
      {
        icon: 'mdi-badge-account',
        title: 'Báo lỗi sản phẩm',
        to: '/error-product',
        roles: ['contact_read']
      },
      {
        icon: 'mdi-facebook',
        title: 'Tài khoản social',
        to: '/zalo/list',
        roles: ['social-account_read']
      },
      {
        to: '',
        title: 'TÀI LIỆU',
        roles: ['training-manager_read', 'training-sale_read'],
      },
      {
        icon: 'mdi-folder-account',
        title: 'Tài liệu training',
        to: '/training',
        roles: ['training-manager_read', 'training-sale_read']
      },
      {
        to: '',
        title: 'QUẢN LÝ',
        roles: ['training-manager_read', 'training-sale_read'],
      },
      {
        icon: 'mdi-folder-account',
        title: 'Quản lý setup kịch bản',
        to: '/manage-setup',
        roles: ['contact_read', 'contact_view_all', 'search_all_read']
      },
      {
        icon: 'mdi-folder-account',
        title: 'Quản lý kịch bản',
        to: '/manage-script',
        roles: ['contact_read', 'contact_view_all', 'search_all_read']
      },
      {
        icon: 'mdi-folder-account',
        title: 'Quản lý BrandName',
        to: '/manage-brand',
        roles: ['contact_read', 'contact_view_all', 'search_all_read']
      },
      {
        to: '/orders/order-payment-checklist',
        icon: 'mdi-cash-check',
        title: 'Đối soát SMS',
        roles: ['reconcile-sms_read', 'reconcile-sms_view_all'],
      },
      {
        to: '/qr-transactions',
        icon: 'mdi-qrcode',
        title: 'Danh sách giao dịch QR',
        roles: ['order_read', 'order_create', 'order_update', 'order_delete', 'order_view_all'],
      },
    ],

    itemsModule: [
      {
        to: '',
        title: 'TƯ VẤN',
        roles: ['contact_read', 'contact_view_all', 'search_all_read', ...roleUsers,
          'order_read', 'order_create', 'order_update', 'order_delete', 'order_view_all', ...roleCallCenter ],
      },
      {
        icon: 'mdi-view-dashboard',
        title: 'Dashboard ',
        to: '/contact/contact-list',
        roles: ['contact_read', 'contact_view_all', 'search_all_read']
      },
      {
        group: '/users',
        icon: 'mdi-account',
        title: 'Dữ liệu cá nhân',
        roles: roleUsers,
        children: [
          {
            title: 'KPI',
            to: 'kpi',
            roles: ['kpi_read', 'kpi_create', 'kpi_update', 'kpi_delete']
          },
          {
            title: 'Lịch làm việc',
            to: 'schedule-list',
            roles: [
              'schedule_read',
              'schedule_create',
              'schedule_update',
              'schedule_delete',
              'schedule_view_all'
            ]
          },
          {
            title: 'Lịch hẹn',
            to: 'appointment',
            roles: [
              'appointment_read',
              'appointment_create',
              'appointment_update',
              'appointment_delete',
              'appointment_view_all'
            ]
          }
        ]
      },
      {
        group: '/call-center',
        icon: 'mdi-file-document',
        title: 'Lịch sử cuộc gọi',
        roles: roleCallCenter,
        children: [
          {
            title: 'Danh sách cuộc gọi',
            to: 'list',
            roles: [
              'call_center_read',
              'call_center_delete',
              'call_center_view_all'
            ]
          }
        ]
      },
      {
        to: '/orders/order-list',
        icon: 'mdi-cash-multiple',
        title: 'Đơn hàng',
        roles: ['order_read', 'order_create', 'order_update', 'order_delete', 'order_view_all'],
      },
      {
        to: '/orders/receipt-list',
        icon: 'mdi-cash-multiple',
        title: 'Danh sách phiếu thu',
        roles: ['order_read', 'order_create', 'order_update', 'order_delete', 'order_view_all'],
      },
      {
        to: '',
        title: 'BÁO CÁO',
        roles: ['result-report_read', 'best-employee_read', 'employee-report_read', 'human-resources-report_read', 'result-report_read', 'status-report_read', 'contact-source-report_read', 'product-group-revenue-report_read'],
      },
      {
        icon: 'mdi-view-dashboard',
        title: 'Báo cáo cá nhân',
        group: '/report',
        roles: ['result-report_read', 'best-employee_read', 'employee-report_read'],
        children: [
          {
            title: 'Báo cáo nhân viên',
            to: 'employee-report-fe',
            roles: ['employee-report_read']
          },
          {
            title: 'Báo cáo thành tích cá nhân',
            to: 'personal-report-fe',
            roles: ['personal-report_read']
          },
          {
            title: 'BC Nhân viên xuất sắc',
            to: 'best-employees',
            roles: ['best-employee_read']
          },
        ]
      },
      {
        group: '/report',
        icon: 'mdi-cash-multiple',
        title: 'Báo cáo quản lý',
        roles: ['human-resources-report_read', 'result-report_read', 'status-report_read',
                'contact-source-report_read', 'delivery-report_read',
                'product-group-revenue-report_read', 'customer-revenue-report_read'],
        children: [
          {
            title: 'Báo cáo nguồn lực',
            to: 'employee-report',
            roles: ['human-resources-report_read']
          },
          {
            title: 'Báo cáo kết quả',
            to: 'result-report',
            roles: ['result-report_read']
          },
          {
            title: 'Theo trạng thái',
            to: 'status-report',
            roles: ['status-report_read']
          },
          {
            title: 'Theo nguồn contact',
            to: 'contact-source-report',
            roles: ['contact-source-report_read']
          },
          {
            title: 'Báo cáo giao hàng',
            to: 'delivery',
            roles: ['delivery-report_read']
          },
          {
            title: 'BC doanh thu',
            group: '/report',
            roles: [
              'product-group-revenue-report_read',
              'customer-revenue-report_read'
            ],
            children: [
              {
                title: 'Theo nhóm sản phẩm',
                to: 'product-group',
                roles: ['product-group-revenue-report_read']
              },
              {
                title: 'Theo nhóm sản phẩm V2',
                to: 'product-group-v2',
                roles: ['product-group-revenue-report_read']
              },
              {
                title: 'Theo khách hàng',
                to: 'customer-report',
                roles: ['customer-revenue-report_read']
              }
            ]
          },
        ]
      },
      {
        to: '',
        title: 'HỖ TRỢ',
        roles: ['contact_read', 'dashboard_read'],
      },
      // {
      //   icon: 'mdi-face-agent',
      //   title: 'Hỗ trợ CSKH',
      //   to: '/customer-support',
      //   roles: ['contact_read', 'dashboard_read']
      // },
      // {
      //   icon: 'mdi-face-agent',
      //   title: 'Hỗ trợ CSKH',
      //   to: '/customer-support-new',
      //   roles: ['contact_read', 'dashboard_read']
      // },
      {
          icon: 'mdi-face-agent',
          title: 'Hỗ trợ CSKH',
          to: '/customer-support-v2',
          roles: 'all'
      },
      // {
      //   icon: 'mdi-face-agent',
      //   title: 'Data BC MKT Bitu',
      //   to: '/bitu-chat',
      //   roles: ['performancep-mkt-detail_read']
      // },
      {
        icon: 'mdi-badge-account',
        title: 'Báo lỗi sản phẩm',
        to: '/error-product',
        roles: ['contact_read']
      },
      {
        icon: 'mdi-facebook',
        title: 'Tài khoản social',
        to: '/zalo/list',
        roles: ['social-account_read']
      },
      {
        to: '/orders/order-payment-checklist',
        icon: 'mdi-cash-check',
        title: 'Đối soát SMS',
        roles: ['reconcile-sms_read', 'reconcile-sms_view_all'],
      },
    ],

    itemsPartner: [
      {
        group: '',
        icon: 'mdi-cash-multiple',
        title: 'CTV',
        roles: ['dashboard-partner_read', 'partner-report_read'],
        children: [
          {
            icon: 'mdi-view-dashboard',
            title: 'Dashboard CTV',
            to: 'dashboard-ctv',
            roles: ['dashboard-partner_read']
          },
          {
            title: 'Báo cáo CTV',
            icon: 'mdi-chart-bar',
            to: 'report/partner-report',
            roles: ['partner-report_read']
          }
        ]
      },
      {
        group: '',
        icon: 'mdi-cash-multiple',
        title: 'Partner',
        roles: ['dashboard_read', 'employee-report-a-department_read'],
        children: [
          {
            icon: 'mdi-view-dashboard',
            title: 'Dashboard Partner',
            to: 'dashboard',
            roles: ['dashboard_read']
          },
          {
            title: 'Báo cáo partner',
            icon: 'mdi-chart-bar',
            to: 'report/employee-report-' + PARTNER,
            roles: ['employee-report-a-department_read']
          },
        ]
      },
      {
        group: '',
        icon: 'mdi-cash-multiple',
        title: 'Quản lý đại lý',
        roles: ['agency-admin_read', 'agency-user_read'],
        children: [
          {
            icon: 'mdi-view-dashboard',
            title: 'Danh sách đại lý',
            to: 'agency',
            roles: ['agency-admin_read', 'agency-user_read'],
          },
          {
            title: 'Danh sách đơn hàng',
            icon: 'mdi-chart-bar',
            to: 'agency/order-list-all',
            roles: ['agency-admin_read', 'agency-user_read'],
          },
          {
            title: 'Báo cáo nhân viên',
            to: 'agency/employee-report',
            roles: ['agency-admin_read', 'agency-user_read'],
          }
        ]
      }
    ],
    expandOnHover: true,
    filterForm: {
      typeId: '',
      schoolLevelId: ''
    },
    listPartnerCtv: [
      {
        name: 'CTV',
        code: 'ctv'
      },
      {
        name: 'Partner',
        code: 'partnert'
      }
    ],
    listSchoolLevelDrawer: [],
    listType: [],
    typeName: '',
    computedItems: [],
    profile: {
      avatar: true,
      avatarPath: TokenService.getAvatarPath(),
      group: '',
      title: TokenService.getFullName(),
      isManager: TokenService.getUser().isManager ? true : false,
      isCTV: TokenService.getUser().isCTV ? true : false,
      typeId: TokenService.getUser().typeId,
      schoolLevelId: TokenService.getUser().schoolLevelId,
      typeName: '',
      schoolLevelName: '',
      isMarketing: TokenService.getUser().isMarketing ? true : false,
    },
    isHover: true,
    projectType: process.env.VUE_APP_NATIONAL_PROJECT_TYPE
  }),

  async created() {
    this.expandOnHover = !checkMobile()
    await this.getListModule();
    this.getFilterForm();
    this.getListItemShowDrawer();
    // await this.getListType();
    await this.getListSchoolLevel();
    Bus.$on('change-menu-side-bar', (filterForm) => {
      this.filterForm.schoolLevelId = filterForm.schoolLevelId
      this.filterForm.typeId = filterForm.typeId
      this.changeDrawer()
    });
    this.getTypeNSchoolLevelName();
  },

  computed: {
    ...mapState(['barColor', 'barImage']),
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit('SET_DRAWER', val);
      }
    },
    typeSchoolLevels() {
      if (this.listType.length > 0 && this.filterForm.typeId) {
        const result = this.listType.find(school => {
          return school.id == this.filterForm.typeId
        })

        return result?.schoolLevel || [{id: '', name: 'Tất cả'}]
      } else return [{id: '', name: 'Tất cả'}]
    },
  },

  methods: {
    mapItem(item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        title: item.title
      };
    },
    getListItemShowDrawer() {
      if((this.profile.isManager && !this.filterForm.typeId) || this.profile.isMarketing) {
        this.computedItems = this.itemsManager.map(this.mapItem);
      } else if(this.profile.isCTV) {
        this.computedItems = this.itemsPartner.map(this.mapItem);
      } else {
        this.computedItems = this.itemsModule.map(this.mapItem);
      }
    },
    changeDrawer() {
      if (this.filterForm.typeId == 'partner') {
        this.computedItems = this.itemsPartner.map(this.mapItem)
        this.filterForm.schoolLevelId = this.typeSchoolLevels[0].id;
        const permissionRoles = this.$store.state.permissions
        if (permissionRoles.includes('dashboard_read')) {
          this.$router.push('/dashboard');
        } else if (permissionRoles.includes('dashboard-partner_read')) {
          this.$router.push('/dashboard-ctv');
        }
      } else {
        if (this.filterForm.typeId && this.typeSchoolLevels.length > 0) {
          this.computedItems = this.itemsModule.map(this.mapItem);
          this.filterForm.schoolLevelId = this.filterForm.schoolLevelId && this.typeSchoolLevels.find(item => item.id == this.filterForm.schoolLevelId)
              ? this.filterForm.schoolLevelId : this.typeSchoolLevels[0].id
        } else {
          this.computedItems = this.itemsManager.map(this.mapItem)
          this.filterForm.schoolLevelId = ''
        }
        if (this.$route.name != 'ContactList') {
          this.$router.push({
            name: 'ContactList'
          })
        }
        this.$store.dispatch('SET_MODULE', {
          typeId: _.get(this.filterForm, 'typeId', ''),
          schoolLevelId: _.get(this.filterForm, 'schoolLevelId', '')
        })
        TokenService.setModule({
          typeId: _.get(this.filterForm, 'typeId', ''),
          schoolLevelId: _.get(this.filterForm, 'schoolLevelId', '')
        })
      }
      Bus.$emit('change-drawer-side-bar', this.filterForm)
    },
    async getListType() {
      if(!this.profile.isCTV) {
        if(this.$store.state.listType) {
          this.listType = _.cloneDeep(this.$store.state.listType);
        } else {
          const response = await TypeRepository.list();
          if (response.success) {
            this.listType = _.get(response, 'data', [])
            this.$store.dispatch('SET_LIST_TYPE', _.get(response, 'data', []))
          }
        }
        this.listType.unshift({
          name: 'Quản trị',
          id: ''
        });
        this.listType.push({
          id: 'partner',
          name: 'Đối tác'
        });
      }
    },
    async getListSchoolLevel() {
      if(this.$store.state.listSchoolLevelDrawer) {
        this.listSchoolLevelDrawer = _.cloneDeep(this.$store.state.listSchoolLevelDrawer)
        if(!this.filterForm.typeId) {
          this.listSchoolLevelDrawer.unshift({
            id: '',
            name: 'Tất cả'
          })
        }
        return
      }

      const loading = this.$loading.show()
      const res = await SchoolLevelRepository.listTypeSchoolLevel()

      if (res.success) {
        this.listSchoolLevelDrawer = _.get(res, 'data', [])
        this.$store.dispatch('SET_LIST_SCHOOL_LEVEL_DRAWER', this.listSchoolLevelDrawer)
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: _.get(res, 'message', '')
        })
      }
      loading.hide()
    },
    getTypeNSchoolLevelName() {
      let indexType = this.listType.findIndex(ite => ite.id === this.filterForm.typeId);
      if(indexType > -1) {
        this.profile.typeName = this.listType[indexType].name
      }

      let indexSch = this.typeSchoolLevels.findIndex(ite => ite.id === this.filterForm.schoolLevelId);
      if(indexSch > -1) {
        this.profile.schoolLevelName = this.typeSchoolLevels[indexSch].name
      }
      if((!this.profile.isManager && !this.profile.isCTV) || (this.profile.isManager && this.filterForm.typeId)) {
        this.computedItems[1].title = `Dashboard ${this.profile.typeName}`;
      }
    },
    getFilterForm() {
      const user = TokenService.getUser();
      this.isManager = user.isManager
      if(user.isManager) {
        this.filterForm.typeId = this.$store.state.module.typeId ? this.$store.state.module.typeId : ''
        this.filterForm.schoolLevelId = this.$store.state.module.schoolLevelId ? this.$store.state.module.schoolLevelId : ''
      } else if (!user.isCTV && !user.isMarketing) {
        this.filterForm.typeId = this.$store.state.module.typeId ? this.$store.state.module.typeId : this.listType[0].id
        this.filterForm.schoolLevelId = this.$store.state.module.schoolLevelId ? this.$store.state.module.schoolLevelId : this.listType[0]?.schoolLevel[0]?.id
      } else {
        this.filterForm.typeId = user.typeId
        this.filterForm.schoolLevelId = user.schoolLevelId
      }
    },
    async getListModule() {
      const user = TokenService.getUser();
      let response = {};
      if (user.isManager) {
        if (this.$store.state.listSchoolLevelDrawer) {
          response['data'] = _.cloneDeep(this.$store.state.listSchoolLevelDrawer)
        } else {
          response = await SchoolLevelRepository.listTypeSchoolLevel()
        }

        response['data'].unshift({
          name: 'Quản trị',
          id: ''
        });

        response['data'].push({
          id: 'partner',
          name: 'Đối tác'
        });

      } else {
        if (this.$store.state.listModuleUser) {
          response['data'] = this.$store.state.listModuleUser
        } else {
          response = await UserRepository.listModuleView()
        }
      }
      this.listType = response?.data || []
    },
  }
};
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    &.v-navigation-drawer--mini-variant
      .v-list-item
        justify-content: flex-start !important

      .v-list-group--sub-group
        display: block !important

      .v-navigation-drawer__content
        overflow-y: hidden
        background: rgb(21, 21, 21, 0.66)

    &.v-navigation-drawer--is-mouseover
      .v-navigation-drawer__content
        overflow-y: auto
        background: rgb(21, 21, 21, 0.66)

    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
<style lang="css">
  /deep/ .v-text-field > .v-input__control > .v-input__slot:before {
    border-style: none;
  }
  a.v-list-item.v-list-item--link.theme--light.classActive .v-list-item__title {
    font-weight: 900;
  }
  .title-module-sale {
    position: absolute;
    bottom: 13px;
    left: 74px;
    color: #FFFFFF;
    font-weight: 600;
  }
  .title-module-sale.no-manager {
    max-height: 25px;
  }
  .title-module-sale .v-select:not(.v-text-field--single-line):not(.v-text-field--outlined) .v-select__slot > input {
    color: #FFFFFF !important;
    font-weight: bold;
  }
  a.item-sidebar .v-list-item__content {
    position: absolute;
    left: 60px;
    top: 2px;
  }
  .v-divider {
    border-color: rgb(255 255 255 / 12%)!important
  }
  .wrapper-is-manager .v-text-field > .v-input__control > .v-input__slot:after {
    border: none !important;
  }
  .wrapper-is-manager .theme--light.v-text-field:not(.v-input--has-state) > .v-input__control > .v-input__slot:hover:before {
    border: none !important;
  }
  .wrapper-is-manager .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
    border: none !important;
  }

  #core-navigation-drawer .item-sidebar .v-list-group__items .v-list-item__icon--text {
    visibility: hidden !important;
  }
  .v-navigation-drawer__content{
    background: #191919!important;
  }
  .title-module-sale.no-manager {
    display: none;
  }
  #core-navigation-drawer:hover .title-module-sale.no-manager {
    display: unset;
  }
</style>
